exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#footerContainer {\n    border-top: 1px black solid;\n    width: 70%;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n}\n\n#footerContainer ul {\n    list-style: none;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    flex-wrap: nowrap;\n}\n\n#footerContainer .reactDisclaimer {\n    font-size: 10px;\n    padding-top: 1%;\n}", ""]);

// exports
